const styles = `
    width: 100% !important;
    margin-top: 15px;
    margin-bottom: 15px;

    & > div {
      margin-left: -10px;
      & > input {
        margin-left: 10px;
        font-size: 28px !important;
        width: 60px !important;
        height: 70px !important;
        background: #FFFFFF !important;
        border: 2px solid #E5E5E5 !important;
        border-radius: 15px !important;
        box-shadow: 0px 10px 10px rgba(0, 0, 0, 0.03) !important;
        font-family: 'Inter' !important; 
        font-weight: 300;

        &:focus{
          border: 2px solid rgba(40, 69, 210, 0.3) !important;
        }

        &::placeholder {
          color: #E5E5E5;
          opacity: 1;
        }

        &:-ms-input-placeholder {
          color: #E5E5E5;
        }

        &::-ms-input-placeholder {
          color: #E5E5E5;
        }
      }
    }
`;

export default styles;
